import { render } from "./RemarquesCard.vue?vue&type=template&id=9de6a2f8"
import script from "./RemarquesCard.vue?vue&type=script&lang=js"
export * from "./RemarquesCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__